import { faBars, faBell, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Navbar, Container } from 'react-bootstrap';

import '../../assets/scss/adminTopbar.scss';
import DarkProfileDropdownMenu from './Sections/DarkProfileDropdownMenu';
import GlobalSearchBar from './Sections/GlobalSearchBar';

interface TopbarProps {
  onToggle: () => void;
}

export default function DarkTopbar(props: TopbarProps) {
  return (
    <Navbar bg="black" className="shadow-sm px-3 position-sticky top-0 top-bar-wrapper">
      <Container fluid className="pe-2">
        <div className="d-flex gap-3">
          <button
            className="btn btn--link hamburger-icon dark-hamburger p-0"
            onClick={props.onToggle}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          {/* <Navbar.Brand>Dashboard</Navbar.Brand> */}
          <GlobalSearchBar isDark={true} />
        </div>
        <div className="d-flex gap-4 align-items-center">
          <div className="position-relative alert-icons">
            <FontAwesomeIcon icon={faBell} />
            <span className="position-absolute start-100 translate-middle badge rounded-pill bg-danger status-badge">
              0
            </span>
          </div>
          <div className="position-relative alert-icons">
            <FontAwesomeIcon icon={faEnvelope} />
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary status-badge">
              0
            </span>
          </div>
          <DarkProfileDropdownMenu />
        </div>
      </Container>
    </Navbar>
  );
}
